import React from "react";

import {
  CheckEmailMessage,
  Container,
  ContentContainer,
  Divider,
  InnerContainer,
  MessageContainer,
  StyledFollowUsOnFacebook,
  StyledIconTickCircle,
  Title,
} from "./styles";

export const SignUpSuccessMessage: React.FunctionComponent = ({ ...props }) => (
  <Container {...props}>
    <InnerContainer>
      <ContentContainer>
        <StyledIconTickCircle />
        <MessageContainer>
          <Title>Thanks for signing up our newsletter!</Title>
          <CheckEmailMessage>
            Please check your email to confirm your newsletter sign-up.
          </CheckEmailMessage>
        </MessageContainer>
      </ContentContainer>
      <Divider />
      <StyledFollowUsOnFacebook />
    </InnerContainer>
  </Container>
);

SignUpSuccessMessage.displayName = "SignUpSuccessMessage";
